import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { globalTheme } from "style/globalTheme";
import styled from "styled-components";
import { brandPalette } from "brand/theme/brandTheme";
import { Grid, Typography } from "@material-ui/core";

const Heading = styled.div`
  height: 15rem;
  padding: 1rem 1.2rem;
  background-image: linear-gradient(
      to right bottom,
      ${brandPalette["Complementary"][200]},
      ${brandPalette["Analogous-1"][600]}
    ),
    url(brand/slide4.jpeg);
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
  display: flex;
  align-items: flex-end;

  h2 {
    font-size: 2rem;
    letter-spacing: 0.07rem;
    text-transform: uppercase;
    font-weight: 700;
    color: white;
    background-image: linear-gradient(
      to right,
      rgba(60, 60, 60, 0.5),
      rgba(0, 28, 48, 0.5)
    );
    padding: 0.5rem 1.5rem;
    border-radius: 8px;
    margin: 0 0 1.5rem 0;
  }
`;

const Content = styled.section`
  padding: 2rem 1rem;
  min-height: 30rem;
  background-color: #fafafa;
`;

const ConnectPlaceholder = ({
  title,
  intro = "This experience will be delivered in an upcoming release.",
}) => (
  <ThemeProvider theme={globalTheme}>
    <Heading>
      <h2>{title}</h2>
    </Heading>
    <Content>
      <Grid container spacing={0}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5" component="h3" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1">
            {intro}
          </Typography>
        </Grid>
      </Grid>
    </Content>
  </ThemeProvider>
);

export default ConnectPlaceholder;


